module.exports = __webpack_public_path__ + "static/media/64.87b1399d.gif";